<app-mobile-login *ngIf="!user.isLoggedIn" (emitLoggedInEvent)="updateLoggedInStatus($event)"></app-mobile-login>
<ng-container *ngIf="user.isLoggedIn">
  <app-choose-module *ngIf="apps.selected_module_name == ''" (emitLogoutEvent)="updateLoggedInStatus($event)"
    (emitModuleName)="setModuleName($event)"></app-choose-module>
  <app-screen-list *ngIf="apps.selected_module_name != ''" (emitLogoutEvent)="updateLoggedInStatus($event)"
    (emitBack)="resetModuleName()" [moduleName]="apps.selected_module_name"></app-screen-list>
</ng-container>
